// External Dependencies:
import React from 'react'
import { DateTime } from 'luxon'

class Calendar extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			todayDateShort: DateTime.local().toLocaleString( DateTime.DATE_SHORT ),
			month: DateTime.local(),
			selected: false
		}
	}

	previousMonth = () => {
		const { month } = this.state

		this.setState( {
			month: month.minus( { months: 1 } )
		} )
	}

	nextMonth = () => {
		const { month } = this.state

		this.setState({
			month: month.plus( { months: 1 } ),
		})
	}

	select( day ) {
		this.setState( {
			selected: day.date,
			month: day.date,
		} )
	}

	renderWeeks() {
		const { renderTileContent } = this.props
		const { month, selected, todayDateShort } = this.state

		// Note: Luxon considers Monday as the first day.

		let weeks = []
		let done = false
		let startOfMonth = month.startOf( 'month' )
		let date

		if ( 7 == startOfMonth.toFormat( 'c' ) ) {
			date = startOfMonth.endOf( 'week' )
		} else {
			date = startOfMonth.minus( { weeks: 1 } ).endOf( 'week' )
		}

		let count = 0
		let monthIndex = date.toFormat( 'L' )

		while ( ! done ) {
			let thisMonth = date.toFormat( 'L' )

			weeks.push(
				<Week
					key={ date }
					todayDateShort={ todayDateShort }
					date={ date }
					currentMonth={ month }
					select={ ( day ) => this.select( day ) }
					selected={ selected }
					renderTileContent={ renderTileContent }
				/>
			)

			date = date.plus( { weeks: 1 } )
			let nextMonth = date.toFormat( 'L' )

			done = count++ > 2 && monthIndex !== nextMonth

			monthIndex = thisMonth
		}

		return weeks
	}

	render() {
		const { month } = this.state

		return (
			<section className="calendar">
				<header>
					<div className="-month-display">
						<i className="-arrow icon-chevron-left" onClick={ this.previousMonth } />

						<span className="-month-label">{ month.toLocaleString( { month: 'long', year: 'numeric' } ) }</span>

						<i className="-arrow icon-chevron-right" onClick={ this.nextMonth } />
					</div>

					<div className="-day-names">
						<span className="-day">Sun</span>
						<span className="-day">Mon</span>
						<span className="-day">Tue</span>
						<span className="-day">Wed</span>
						<span className="-day">Thu</span>
						<span className="-day">Fri</span>
						<span className="-day">Sat</span>
					</div>
				</header>

				<div className="-weeks-wrap">
					{ this.renderWeeks() }
				</div>
			</section>
		)
	}
}

class Week extends React.Component {
	render() {
		let { date, currentMonth, selected, select, todayDateShort, renderTileContent } = this.props
		let days = []

		for ( var i = 0; i < 7; i++ ) {
			let day = {
				name: date.toFormat( 'LLLLL' ),
				year: date.toFormat( 'y' ),
				monthNumber: date.toFormat( 'L' ),
				monthNumberPadded: date.toFormat( 'LL' ),
				dayNumber: date.toFormat( 'd' ),
				dayNumberPadded: date.toFormat( 'dd' ),
				dayOfWeekNumber: date.toFormat( 'c' ),
				isCurrentMonth: date.toFormat( 'L' ) === currentMonth.toFormat( 'L' ),
				isToday: date.toLocaleString( DateTime.DATE_SHORT ) == todayDateShort,
				date: date
			}

			days.push(
				<Day
					key={ day.dayNumber }
					day={ day }
					selected={ selected }
					select={ select }
					renderTileContent={ renderTileContent }
				/>
			)

			date = date.plus( { days: 1 } )
		}

		return (
			<div className="-week" key={ days[0] }>
				{ days }
			</div>
		)
	}

}

class Day extends React.Component {
	render() {
		const {
			day,
			day: {
				name,
				year,
				monthNumber,
				dayNumber,
				dayNumberPadded,
				dayOfWeekNumber,
				isCurrentMonth,
				isToday,
				date
			},
			select,
			selected,
			renderTileContent
		} = this.props
		const content = renderTileContent( day )
		let className = `-day -day-n-${dayOfWeekNumber}`

		if ( content ) {
			className += ' has-content'
		}

		if ( isToday ) {
			className += ' is-today'
		}

		if ( ! isCurrentMonth ) {
			className += ' is-different-month'
		}

		if ( date.hasSame( selected, 'day' ) ) {
			className += ' is-selected'
		}

		return (
			<span
				key={ date.toString() }
				className={ className }
				onClick={ () => select( day ) }>
				<div className="-number">{ dayNumber }</div>
				{ content }
			</span>
		)
	}
}

export default Calendar
